import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'female-glp',
	options: {
		userTags: ['glp'],
	},
	landing: {
		ids: ['loader-f-glp'],
		route: {
			path: '/glp-f',
			name: 'female-glp-funnel',
		},
	},
	funnel: {
		id: 'ob-female-glp',
		route: {
			path: '/glp-f/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-glp-onboarding',
		},
		slug: 'female-glp',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-glp-f',
	},
	upsell: { routeNames: ['upsell-static-subscription-activated', 'upsell-f'] },
}

export default appAreaConfig
